import axios from 'axios';
import auth from '../authentication';
import store from '../store';
//import axiosRetry from 'axios-retry';
import { eventHub } from './eventhub';

const ajax = axios.create({
    baseURL: process.env.VUE_APP_API_URL

});

ajax.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
ajax.CancelToken = axios.CancelToken;
ajax.isCancel = axios.isCancel;

//axiosRetry(ajax, { retries: 2 });

/*
 * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
 */
ajax.interceptors.request.use(
    async (config) => {
        eventHub.$emit('before-request');
        let token = await auth.acquireToken();
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['User'] = store.getters["usuario"];

        return config;
    },
    (error) => {
        eventHub.$emit('request-error', error);
        return Promise.reject(error);
    }
);

ajax.interceptors.response.use(
    response => {
        eventHub.$emit('after-response');
        return response;
    },
    error => {
        eventHub.$emit('response-error', error);
        return Promise.reject(error);
    }
);

export default ajax

